import { Button, HFlow, Modal, ModalBody, ModalFooter, ModalHeader, Text, Theme, useStyles, VFlow } from 'bold-ui'
import { DateTime } from 'components/date'
import { Age } from 'components/date/Age'
import { Cpf } from 'components/label'
import React, { CSSProperties } from 'react'
import { identidadeGeneroRecord, sexoRecord } from 'types/enums'
import { CidadaoListingFormModel } from 'view/cidadao/types/model-pesquisarCidadao'

interface UnificacaoCadastroConfirmacaoModalProps {
  openConfirmModal: boolean
  cancelarConfirmacao(): void
  unificarCidadaos(): void
  cadastroResultante: CidadaoListingFormModel
  cnsCadastroResultante: string
  cpfCadastroResultante: string
  unidadeResponsavelResultante: string
}

export function UnificacaoCadastroConfirmacaoModal(props: UnificacaoCadastroConfirmacaoModalProps) {
  const { classes } = useStyles(createStyles)
  const {
    openConfirmModal,
    cancelarConfirmacao,
    unificarCidadaos,
    cadastroResultante,
    cnsCadastroResultante,
    cpfCadastroResultante,
    unidadeResponsavelResultante,
  } = props
  return (
    <Modal
      open={openConfirmModal}
      onClose={cancelarConfirmacao}
      closeOnBackdropClick={false}
      style={{ width: '42.5rem' }}
    >
      <ModalHeader
        title='Deseja confirmar a unificação de prontuários?'
        subtitle='O cadastro do cidadão ficará com os seguintes dados:'
        icon={{ name: 'questionMarkFilled', fill: 'info' }}
      />
      <ModalBody>
        <VFlow style={classes.container} vSpacing={1}>
          <HFlow hSpacing={0.5} alignItems='baseline'>
            {cadastroResultante.nomeSocial ? (
              <span>
                <Text fontSize={1} fontWeight='bold'>
                  {cadastroResultante.nomeSocial}
                </Text>
                {cadastroResultante.nomeSocial && <Text fontWeight='bold'> (Nome social)</Text>}
                {cadastroResultante.nomeSocial && <Text>{' | ' + cadastroResultante.nome?.titleCase()}</Text>}
              </span>
            ) : (
              <Text fontSize={1} fontWeight='bold'>
                {cadastroResultante.nome?.titleCase()}
              </Text>
            )}
          </HFlow>
          <VFlow vSpacing={0}>
            <HFlow>
              <HFlow hSpacing={0.5} data-cy='ModalConfirmar.CPF'>
                <Text fontWeight='bold'>CPF</Text>
                {cpfCadastroResultante ? <Cpf value={cpfCadastroResultante} /> : '-'}
              </HFlow>
              <HFlow hSpacing={0.5} data-cy='ModalConfirmar.CNS'>
                <Text fontWeight='bold'>CNS</Text>
                {cnsCadastroResultante ? <Text>{cnsCadastroResultante}</Text> : '-'}
              </HFlow>
            </HFlow>
            <HFlow hSpacing={0.5} data-cy='ModalConfirmar.DataNascimento'>
              <Text fontWeight='bold'>Data de nascimento</Text>
              <DateTime format='DD/MM/YYYY' value={cadastroResultante?.dataNascimento} />
              <Age dateOfBirth={cadastroResultante?.dataNascimento} />
            </HFlow>
            <HFlow hSpacing={0.5}>
              <Text fontWeight='bold'>Sexo</Text>
              <Text data-cy='ModalConfirmar.Sexo'> {sexoRecord[cadastroResultante?.sexo]}</Text>
              <Text fontWeight='bold'>{cadastroResultante?.identidadeGeneroDbEnum ? 'Id. de gênero' : null}</Text>
              <Text data-cy='ModalConfirmar.IdGenero'>
                {cadastroResultante?.identidadeGeneroDbEnum &&
                  identidadeGeneroRecord[cadastroResultante?.identidadeGeneroDbEnum]}
              </Text>
            </HFlow>
          </VFlow>
          <VFlow vSpacing={0}>
            <HFlow data-cy='ModalConfirmar.NomeMae'>
              <Text fontWeight='bold'>Nome da mãe</Text>
              <Text>{cadastroResultante?.nomeMae ? cadastroResultante?.nomeMae?.titleCase() : '-'}</Text>
            </HFlow>
            <HFlow data-cy='ModalConfirmar.UnidadeResponsavel'>
              <Text fontWeight='bold'>Unidade responsável</Text>
              <Text>{unidadeResponsavelResultante?.titleCase() ?? '-'}</Text>
            </HFlow>
            <HFlow data-cy='ModalConfirmar.MunicipioNascimento'>
              <Text fontWeight='bold'>Município de nascimento</Text>
              <Text>
                {cadastroResultante?.localidadeNascimento
                  ? `${cadastroResultante?.localidadeNascimento?.nome?.titleCase()} - ${
                      cadastroResultante?.localidadeNascimento?.uf?.sigla
                    }`
                  : '-'}
              </Text>
            </HFlow>
          </VFlow>
        </VFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' size='medium' onClick={cancelarConfirmacao} data-cy='CancelarButton'>
            Cancelar
          </Button>
          <Button kind='primary' skin='default' size='medium' onClick={unificarCidadaos}>
            Confirmar unificação
          </Button>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}

const createStyles = (theme: Theme) => ({
  container: {
    border: `1px solid ${theme.pallete.divider}`,
    padding: '1rem',
    textAlign: 'left',
    margin: '2.35rem 0 0 0',
  } as CSSProperties,
  nomeCidadao: {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
  } as CSSProperties,
})
